import { useEffect } from 'react';
// next
import { useRouter } from 'next/router';
// hooks
import useAuth from '@common/hooks/useAuth';
// routes
import { PATH_DASHBOARD } from '../routes/paths';

import { DefaultGuardProps } from '@common/@types/guards';

// ----------------------------------------------------------------------

export default function GuestGuard({ children }: DefaultGuardProps) {
  const { push } = useRouter();

  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (isAuthenticated) {
      push(PATH_DASHBOARD.root);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  return <>{children}</>;
}
